export default `
§ sidebar.switch.team: 专责小组
§ sidebar.switch.person: 雇员
§ sidebar.buttons.settings: 设置
§ sidebar.buttons.print: 印刷业
§ sidebar.buttons.share: Share
§ sidebar.buttons.logout: Logout
§ sidebar.filters.all: 一直
§ sidebar.filters.year: 年份
§ sidebar.filters.halfYear: 半年
§ sidebar.filters.month: 月份
§ sidebar.filters.week: 周
§ sidebar.team.total: 般资料
§ sidebar.team.scope: 功能
§ sidebar.team.author: 员工
§ sidebar.team.type: 任务类型
§ sidebar.team.pr: 代码注入
§ sidebar.team.day: 白天
§ sidebar.team.week: 按星期计算
§ sidebar.team.month: 按月计算
§ sidebar.team.tree: 文件分析
§ sidebar.team.files: 档案
§ sidebar.team.removedFiles: 删除的文件
§ sidebar.team.tasks: 任务列表
§ sidebar.team.hours: 时间表
§ sidebar.team.commits: All commits
§ sidebar.team.changes: 所有更改
§ sidebar.team.words: 流行语
§ sidebar.team.top: 测验
§ sidebar.team.settings: 设置
§ sidebar.person.total: 般资料
§ sidebar.person.money: 工作的成本
§ sidebar.person.speed: 速度
§ sidebar.person.day: 白天
§ sidebar.person.week: 按星期计算
§ sidebar.person.month: 按月计算
§ sidebar.person.hours: 时间表
§ sidebar.person.commits: All commits
§ sidebar.person.changes: 所有更改
§ sidebar.person.words: 流行语
§ sidebar.person.settings: 设置
`;
